import { z } from "zod";

export const MediumSchema = z.enum(["face_to_face", "phone", "video"]);
export type Medium = z.infer<typeof MediumSchema>;

export const PurposeSchema = z.enum(["discharge_call", "follow_up", "general", "hybrid_call", "kick_off"]);
export type Purpose = z.infer<typeof PurposeSchema>;

export const StateSchema = z.enum([
  "canceled",
  "completed",
  "confirmed",
  "expired",
  "no_show",
  "pending",
  "rescheduled",
]);
export type State = z.infer<typeof StateSchema>;
